import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './Components/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/style/styles.scss";
import {useRoutes} from "./Route/router"
import Footer from './Components/Footer';


function App() {
  const routes=useRoutes(false)
  return (
    <Router>
    <Header/>
    
      {routes}
  <Footer/>
  </Router>
  );
}

export default App;
